import { motion, useReducedMotion } from "framer-motion";
import { Magnetic } from "@/components/site/Magnetic";
import { fireBurst } from "@/components/site/ConfettiLayer";
import { ACCENTS } from "@/data/site";

// Square-cornered CTA. variant: "red" | "black" | "outline".
export const CtaButton = ({
  children,
  variant = "black",
  onClick,
  burst = false,
  burstColor = ACCENTS.red,
  className = "",
  ...rest
}) => {
  const reduce = useReducedMotion();
  const base =
    "inline-flex items-center justify-center gap-2 px-8 py-4 text-xs font-bold uppercase tracking-[0.18em] transition-colors duration-300";
  const variants = {
    red: "bg-owo-pink text-ink hover:bg-[#ef7ba6]",
    black: "bg-owo-pink text-ink hover:bg-[#ef7ba6]",
    outline: "border border-ink text-ink bg-transparent hover:bg-owo-pink hover:text-ink",
  };

  const handleClick = (e) => {
    if (burst && !reduce) fireBurst(e.clientX, e.clientY, burstColor);
    onClick?.(e);
  };

  return (
    <Magnetic strength={0.4} className="inline-block">
      <motion.button
        type="button"
        onClick={handleClick}
        whileHover={reduce ? undefined : { y: -4 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
        className={`${base} ${variants[variant]} ${className}`}
        data-cursor-color={variant === "blue" ? ACCENTS.blue : ACCENTS.red}
        {...rest}
      >
        {children}
      </motion.button>
    </Magnetic>
  );
};
